export default "__VITE_PUBLIC_ASSET__1c50ad2c__"